export default __webpack_public_path__ + "static/media/u_wdt_c_1.454d6d2b.mp3";